// Balanzas de pedestal (packing) - Productos con ID 1000-1099
const balanzasPedestalPacking = [
  {
    id: 1001,
    categoria: 'balanzas-pedestal-packing',
    nombre: 'BALANZA DE PEDESTAL 60X45CM PACKING',
    descripcion: 'Solución compacta, robusta y precisa para tareas de pesaje en entornos comerciales, industriales o logísticos. Equipo compacto con columna e indicador LP7516.',
    descripcion2: 'Balanza de pedestal compacta con autonomía extendida y múltiples capacidades y dimensiones. Ideal para packing con funciones especiales de etiquetado, filtros digitales para líneas con vibración y conectividad avanzada. Perfecta para comercios, industrias, depósitos y control de stock.',
    imagen: '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x45-packing-1.webp',
    caracteristicas: [
      {
        titulo: 'Plataforma',
        items: [
          '• Material: Estructura metálica reforzada con cubierta lisa en acero inoxidable (fácil limpieza)',
          '• Célula de carga: Alta precisión con protección IP65/IP67',
          '• Precisión / resolución: Desde 1 g a 200 g (según capacidad y dimensión)',
          '• Montaje: Sobre columna o sobremesa'
        ]
      },
      {
        titulo: 'Indicador',
        items: [
          '• Modelo: LP7516',
          '• Pantalla: LED de alto brillo o LCD retroiluminada (según versión)',
          '• Carcasa: ABS de alta resistencia'
        ]
      },
      {
        titulo: 'Conectividad y Datos',
        items: [
          '• Bluetooth (OPCIONAL) para transmisión inalámbrica a PC/tablet/móvil',
          '• Puertos: RS-232 (impresoras/PC) y opciones Ethernet/Wi-Fi'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          '• Batería interna recargable + adaptador 220V',
          '• Autonomía: Hasta 60 horas de uso continuo',
          '• Indicador de nivel de batería'
        ]
      },
      {
        titulo: 'Funciones "Especial Packing"',
        items: [
          '• Etiquetado (opcional): neto/tara/bruto, lote, fecha/hora, operario y código de producto',
          '• Filtros digitales para líneas con vibración'
        ]
      },
      {
        titulo: 'Aplicaciones',
        items: [
          '• Comercios mayoristas y minoristas',
          '• Industrias y talleres',
          '• Depósitos, embalaje y control de stock',
          '• Laboratorios, distribuidoras y puntos de control de carga'
        ]
      }
    ],
    opciones: [
      {
        id: 'pedestal-60x45-packing',
        nombre: 'BALANZA DE PEDESTAL 60X45CM PACKING',
      }
    ],
    imagenes: [
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x45-packing-1.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x45-packing-2.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x45-packing-3.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x45-packing-4.webp'
    ]
  },
  {
    id: 1002,
    categoria: 'balanzas-pedestal-packing',
    nombre: 'BALANZA DE PEDESTAL 30X40CM PACKING',
    descripcion: 'Solución compacta, robusta y precisa para tareas de pesaje en entornos comerciales, industriales o logísticos. Equipo compacto con columna e indicador LP7516.',
    descripcion2: 'Balanza de pedestal compacta con autonomía extendida y múltiples capacidades y dimensiones. Ideal para packing con funciones especiales de etiquetado, filtros digitales para líneas con vibración y conectividad avanzada. Perfecta para comercios, industrias, depósitos y control de stock.',
    imagen: '/imagenes/productos/BalanzasPedestalPacking/pedestal-30x40-packing-1.webp',
    caracteristicas: [
      {
        titulo: 'Plataforma',
        items: [
          '• Material: Estructura metálica reforzada con cubierta lisa en acero inoxidable (fácil limpieza)',
          '• Célula de carga: Alta precisión con protección IP65/IP67',
          '• Precisión / resolución: Desde 1 g a 200 g (según capacidad y dimensión)',
          '• Montaje: Sobre columna o sobremesa'
        ]
      },
      {
        titulo: 'Indicador',
        items: [
          '• Modelo: LP7516',
          '• Pantalla: LED de alto brillo o LCD retroiluminada (según versión)',
          '• Carcasa: ABS de alta resistencia'
        ]
      },
      {
        titulo: 'Conectividad y Datos',
        items: [
          '• Bluetooth (OPCIONAL) para transmisión inalámbrica a PC/tablet/móvil',
          '• Puertos: RS-232 (impresoras/PC) y opciones Ethernet/Wi-Fi'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          '• Batería interna recargable + adaptador 220V',
          '• Autonomía: Hasta 60 horas de uso continuo',
          '• Indicador de nivel de batería'
        ]
      },
      {
        titulo: 'Funciones "Especial Packing"',
        items: [
          '• Etiquetado (opcional): neto/tara/bruto, lote, fecha/hora, operario y código de producto',
          '• Filtros digitales para líneas con vibración'
        ]
      },
      {
        titulo: 'Aplicaciones',
        items: [
          '• Comercios mayoristas y minoristas',
          '• Industrias y talleres',
          '• Depósitos, embalaje y control de stock',
          '• Laboratorios, distribuidoras y puntos de control de carga'
        ]
      }
    ],
    opciones: [
      {
        id: 'pedestal-30x40-packing',
        nombre: 'BALANZA DE PEDESTAL 30X40CM PACKING',
      }
    ],
    imagenes: [
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-30x40-packing-1.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-30x40-packing-2.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-30x40-packing-3.webp'
    ]
  },
  {
    id: 1003,
    categoria: 'balanzas-pedestal-packing',
    nombre: 'BALANZA DE PEDESTAL 60X50CM PACKING',
    descripcion: 'Solución compacta, robusta y precisa para tareas de pesaje en entornos comerciales, industriales o logísticos. Equipo compacto con columna e indicador LP7516.',
    descripcion2: 'Balanza de pedestal compacta con autonomía extendida y múltiples capacidades y dimensiones. Ideal para packing con funciones especiales de etiquetado, filtros digitales para líneas con vibración y conectividad avanzada. Perfecta para comercios, industrias, depósitos y control de stock.',
    imagen: '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x50-packing-1.webp',
    caracteristicas: [
      {
        titulo: 'Plataforma',
        items: [
          '• Material: Estructura metálica reforzada con cubierta lisa en acero inoxidable (fácil limpieza)',
          '• Célula de carga: Alta precisión con protección IP65/IP67',
          '• Precisión / resolución: Desde 1 g a 200 g (según capacidad y dimensión)',
          '• Montaje: Sobre columna o sobremesa'
        ]
      },
      {
        titulo: 'Indicador',
        items: [
          '• Modelo: LP7516',
          '• Pantalla: LED de alto brillo o LCD retroiluminada (según versión)',
          '• Carcasa: ABS de alta resistencia'
        ]
      },
      {
        titulo: 'Conectividad y Datos',
        items: [
          '• Bluetooth (OPCIONAL) para transmisión inalámbrica a PC/tablet/móvil',
          '• Puertos: RS-232 (impresoras/PC) y opciones Ethernet/Wi-Fi'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          '• Batería interna recargable + adaptador 220V',
          '• Autonomía: Hasta 60 horas de uso continuo',
          '• Indicador de nivel de batería'
        ]
      },
      {
        titulo: 'Funciones Especial',
        items: [
          '• Etiquetado (opcional): neto/tara/bruto, lote, fecha/hora, operario y código de producto',
          '• Filtros digitales para líneas con vibración'
        ]
      },
      {
        titulo: 'Aplicaciones',
        items: [
          '• Comercios mayoristas y minoristas',
          '• Industrias y talleres',
          '• Depósitos, embalaje y control de stock',
          '• Laboratorios, distribuidoras y puntos de control de carga'
        ]
      }
    ],
    opciones: [
      {
        id: 'pedestal-60x50-packing',
        nombre: 'BALANZA DE PEDESTAL 60X50CM PACKING',
      }
    ],
    imagenes: [
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x50-packing-1.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x50-packing-2.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-60x50-packing-3.webp'
    ]
  },
  {
    id: 1004,
    categoria: 'balanzas-pedestal-packing',
    nombre: 'BALANZA DE PEDESTAL INDUSTRIAL',
    descripcion: 'Solución compacta, robusta y precisa para tareas de pesaje en entornos comerciales, industriales o logísticos. Equipo compacto con columna e indicador LP7516.',
    descripcion2: 'Balanza de pedestal industrial con autonomía extendida y múltiples capacidades y dimensiones. Ideal para aplicaciones industriales con funciones especiales de etiquetado, filtros digitales para líneas con vibración y conectividad avanzada. Perfecta para comercios, industrias, depósitos y control de stock.',
    imagen: '/imagenes/productos/BalanzasPedestalPacking/pedestal-industrial-1.webp',
    caracteristicas: [
      {
        titulo: 'Plataforma',
        items: [
          '• Material: Estructura metálica reforzada con cubierta lisa en acero inoxidable (fácil limpieza)',
          '• Célula de carga: Alta precisión con protección IP65/IP67',
          '• Precisión / resolución: Desde 1 g a 200 g (según capacidad y dimensión)',
          '• Montaje: Sobre columna o sobremesa'
        ]
      },
      {
        titulo: 'Indicador',
        items: [
          '• Modelo: LP7516',
          '• Pantalla: LED de alto brillo o LCD retroiluminada (según versión)',
          '• Carcasa: ABS de alta resistencia'
        ]
      },
      {
        titulo: 'Conectividad y Datos',
        items: [
          '• Bluetooth (OPCIONAL) para transmisión inalámbrica a PC/tablet/móvil',
          '• Puertos: RS-232 (impresoras/PC) y opciones Ethernet/Wi-Fi'
        ]
      },
      {
        titulo: 'Alimentación',
        items: [
          '• Batería interna recargable + adaptador 220V',
          '• Autonomía: Hasta 60 horas de uso continuo',
          '• Indicador de nivel de batería'
        ]
      },
      {
        titulo: 'Funciones Especial',
        items: [
          '• Etiquetado (opcional): neto/tara/bruto, lote, fecha/hora, operario y código de producto',
          '• Filtros digitales para líneas con vibración'
        ]
      },
      {
        titulo: 'Aplicaciones',
        items: [
          '• Comercios mayoristas y minoristas',
          '• Industrias y talleres',
          '• Depósitos, embalaje y control de stock',
          '• Laboratorios, distribuidoras y puntos de control de carga'
        ]
      }
    ],
    opciones: [
      {
        id: 'pedestal-industrial-30x40',
        nombre: '30X40CM',
      },
      {
        id: 'pedestal-industrial-40x50',
        nombre: '40X50CM',
      },
      {
        id: 'pedestal-industrial-45x60',
        nombre: '45X60CM',
      },
      {
        id: 'pedestal-industrial-60x60',
        nombre: '60X60CM',
      },
      {
        id: 'pedestal-industrial-80x80',
        nombre: '80X80CM',
      }
    ],
    imagenes: [
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-industrial-1.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-industrial-2.webp',
      '/imagenes/productos/BalanzasPedestalPacking/pedestal-industrial-3.webp'
    ]
  },
  {
    id: 1005,
    categoria: 'balanzas-pedestal-packing',
    nombre: 'BALANZA DE PEDESTAL INOXIDABLE',
    descripcion: 'Plataforma de pesaje tipo bench, 100% acero inoxidable AISI 304, pensada para uso intensivo en procesos con humedad, lavado y ambientes corrosivos. ',
    descripcion2: 'Plataforma de pesaje tipo bench, 100% acero inoxidable AISI 304, pensada para uso intensivo en procesos con humedad, lavado y ambientes corrosivos. Estructura soldada robusta, cubierta en INOX de 1,5 mm, celda encapsulada de acero inoxidable con protección IP67/IP68 y patas niveladoras en INOX. Ideal para industria alimentaria, pesquera, agrícola y logística. ',
    imagen: '/imagenes/productos/BalanzasPedestalPacking/fullinox1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Construcción: AISI 304, superficies sanitarias y de fácil limpieza.',
          '•	Cubierta: plancha inoxidable 1,5 mm.',
          '•	Celda de carga: encapsulada en INOX, sellada (IP67/68).',
          '•	Apoyo: 4 patas niveladoras inox M12; opción ruedas.',
          '•	Conexión: Caja sumadora/cableado en INOX (según capacidad).',
          '•	Aplicación: salas de proceso, cámaras de frío y líneas de empaque. ',
          
        ]
      },
      {
        titulo: 'Modelos:',
        items: [
          '•	30×40 cm: capacidades 30/60 kg',
          '•	40×50 cm: capacidades 150/300 kg ',
          '•	50x60cm: capacidad 300/500 kg',
          '•	60×60 cm: capacidad 500 kg',
          '•	60×70 cm: capacidad 500 kg',
          
        ]
      }
    ],
    opciones: [
      {
        id: 'fullinox-3040',
        nombre: '30×40 cm capacidades 30/60 kg  ',
        
      },
      {
        id: 'fullinox-4050',
        nombre: '40×50 cm capacidades 150/300 kg',
        
      },
      
      {
        id: 'fullinox-5060',
        nombre: '50x60cm capacidad 300/500 kg',
        
      },
      
      {
        id: 'fullinox-6060',
        nombre: '60×60 cm capacidad 500 kg',
        
      },
      {
        id: 'fullinox-6070',
        nombre: '60×70 cm capacidad 500 kg',
        
      },
    
      
    ],
    imagenes: [
      '/imagenes/productos/BalanzasPedestalPacking/fullinox1.webp',
      '/imagenes/productos/BalanzasPedestalPacking/fullinox2.webp',
      '/imagenes/productos/BalanzasPedestalPacking/fullinox3.webp',
      '/imagenes/productos/BalanzasPedestalPacking/fullinox4.webp',

    ]
  },
];

export default balanzasPedestalPacking;
